module.exports = __webpack_public_path__ + "media/reimagine-sample.b0fe5032.mp4";